import { defineMessages } from "react-intl"

export default defineMessages({
  authorizationMessage: {
    defaultMessage:
      "You authorize {customerName} to obtain information about your background including obtaining your vehicle or driving record. By completing the registration you agree to our ",
    id: "src.components.WebAppPortal.DriverLicense.authorizationMessage",
  },
  dateOfBirth: {
    defaultMessage: "Date of Birth",
    id: "src.components.WebAppPortal.DriverLicense.dateOfBirth",
  },
  dateOfBirthIsRequired: {
    defaultMessage: "Date of Birth is required",
    id: "src.components.WebAppPortal.DriverLicense.dateOfBirthIsRequired",
  },
  documentPreview: {
    defaultMessage: "document preview",
    id: "src.components.WebAppPortal.DriverLicense.documentPreview",
  },
  error: {
    defaultMessage: "Error",
    id: "src.components.WebAppPortal.DriverLicense.error",
  },
  expirationDate: {
    defaultMessage: "Expiration Date",
    id: "src.components.WebAppPortal.DriverLicense.expirationDate",
  },
  expirationDateIsRequired: {
    defaultMessage: "Expiration date is required",
    id: "src.components.WebAppPortal.DriverLicense.expirationDateIsRequired",
  },
  externalDriverId: {
    defaultMessage: "Fiscal Code",
    id: "src.components.WebAppPortal.AccountCreation.externalDriverId",
  },
  externalDriverIdRequired: {
    defaultMessage: "Fiscal Code required",
    id: "src.components.WebAppPortal.DriverLicense.externalDriverIdRequired",
  },
  externalDriverIdShouldBeAlphaNumeric: {
    defaultMessage:
      "Fiscal Code must contain alpha numeric characters only a-z A-Z 0-9",
    id:
      "src.components.WebAppPortal.DriverLicense.externalDriverIdShouldBeAlphaNumeric",
  },
  license: {
    defaultMessage: "License",
    id: "src.components.WebAppPortal.DriverLicense.license",
  },
  licenseIsRequired: {
    defaultMessage: "license is required",
    id: "src.components.WebAppPortal.DriverLicense.licenseIsRequired",
  },
  memberAgreement: {
    defaultMessage: "Member Agreement.",
    id: "src.components.WebAppPortal.DriverLicense.memberAgreement",
  },
  name: {
    defaultMessage: "Name",
    id: "src.components.WebAppPortal.DriverLicense.name",
  },
  nameIsRequired: {
    defaultMessage: "Name is required",
    id: "src.components.WebAppPortal.DriverLicense.nameIsRequired",
  },
  next: {
    defaultMessage: "Next",
    id: "src.components.WebAppPortal.DriverLicense.next",
  },
  pleaseVerifyYourInformation: {
    defaultMessage: "Please verify your information",
    id: "src.components.WebAppPortal.DriverLicense.pleaseVerifyYourInformation",
  },
  province: {
    defaultMessage: "Province",
    id: "src.components.WebAppPortal.DriverLicense.province",
  },
  provinceIsRequired: {
    defaultMessage: "province is required",
    id: "src.components.WebAppPortal.DriverLicense.provinceIsRequired",
  },
  uploadDocumentMessage: {
    defaultMessage:
      "To make sure you're really you, we'll now ask you to take some photos for verification.",
    id: "src.components.WebAppPortal.DriverLicense.uploadDocumentMessage",
  },
})
